// extracted by mini-css-extract-plugin
export default {"card":"g2-z"};